
import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,

        	// NOTE :::::::::::::::::::::::::::: that how's the widget looks like
        	/* 
        		<div class="hero-image image-control-js" data-height="auto" data-min-height="500" data-max-height="1000">
                    <div class="img-wrapper autosize autosize" data-width="1050" data-height="1400" style="padding-bottom:133.33333333333%;">
                        <img/>
                    </div>
                </div>
            */

            objectFit: 'contain', // 'cover'
            objectPosition: 'left top'
       };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'image-control-size';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
        this.$win           =   $(window);
		

        this.init();
    }

    init(){
        this.min = parseInt( this.$el.attr( 'data-min-height' ) );
        this.max = parseInt( this.$el.attr( 'data-max-height' ) );
        this.mode = this.$el.attr( 'data-mode' );
        this.$wrap = this.$el.find( '.img-wrapper' );
        this.$img = this.$wrap.find( 'img' );
        this.prop = this.$el.height()/this.$el.width();

        //console.log( this.prop );

        this.paddingAutosize = (this.$el.height()/this.$el.width()*100) + '%';

        //console.log( this.paddingAutosize );

    	this.addEvents( true );
	}

    addEvents( b ){
        this.debounceResize(b);
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
            this.onResize();
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){

        let $wrapper = this.$el.parent( '.image-for-video-wrapper' ), availWidth = this.$el.parents( '.span_10' ).width(), w;

        if ( $wrapper.length > 0 ){
            $wrapper.css({
                width:      '100%',
                margin:     '0 auto'
            });

        }

        this.$el.css({
            width:      '100%',
            margin:     '0 auto'
        });

        // reset to its natural size
        this.$wrap.css({
            'padding-bottom'    : this.paddingAutosize,
            'height'            : 'auto',
            //'width'             : 'auto'
        });

        // constarin min/max if not in range
        let h = this.$el.height();


        if ( this.mode === 'costrain' ){
            let availableHeight = this.$win.height() - this.$el.offset().top,  $limit = $( '.' + this.$el.attr( 'data-limit' ) );
            if ( $limit.length > 0 ){
                availableHeight -= Math.min( 79 + 64*2, ($limit.height() + 2*parseInt($limit.css( 'margin-bottom' ))) );
            }
            this.max = Math.max( this.min, availableHeight);

            //console.log( $limit.outerHeight() );
        }
        

        if ( this.$win.width() < 1024 ){
            return;
        }

        if ( h < this.min || h > this.max ){

            h = Math.min( Math.max( h, this.min), this.max );

            this.$wrap.css({
                'padding-bottom'    : 0,
                //'width'             : h/this.prop,
                'height'            : h,
            });

            if ( this.mode === 'costrain' ){

                w = h/this.prop;

                console.log( w + ',' + availWidth );

                if ( w > availWidth ){
                    w = availWidth;
                    this.$wrap.css({
                        'padding-bottom'    : this.paddingAutosize,
                        'height'            : 'auto',
                    });
                }

                this.$el.width( w );
                if ( $wrapper.length > 0 ){
                    $wrapper.width( this.$el.width() );
                }
            }




            /*
            this.$img.css({
                'object-fit' : this.options.objectFit,
                'object-position' : this.options.objectPosition
            })
            */
        }

        
    }
    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        this.addEvents( false );
    }

}